import React from 'react';
import { Redirect, Route, Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import { APIErrorNotification } from 'common/components';
import { Typography as T } from 'common/typography';

import DraftVenueEditorConfirm from './ConfirmTab/DraftVenueEditorConfirm';
import DraftVenueEditorGeneral from './GeneralTab/DraftVenueEditorGeneral';
import Navigation from './Navigation';
import DraftVenueEditorOpeningHours from './OpeningHoursTab/DraftVenueEditorOpeningHours';
import useDraftVenue from '../DraftVenueListPage/useDraftVenue';
import { reportInitialVenuesSetup } from '../behavioral';

type Props = {
  className?: string;
  onSaveSuccess: () => void;
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Wrapper = styled.div`
  box-sizing: border-box;
  padding: 64px 16px;
  max-width: 600px;
  width: 100%;
`;

const Heading = styled(T.Heading1)`
  text-align: center;
  margin-block-end: 40px;
`;

const StyledNavigation = styled(Navigation)`
  margin-block-end: 32px;
`;

const DraftVenueEditor = ({ className, onSaveSuccess }: Props) => {
  const { url, path } = useRouteMatch();
  const history = useHistory();
  const { merchantId, venueId } = useParams<{ merchantId: string; venueId: string }>();
  const { data: draftVenue, error: draftVenueError } = useDraftVenue(merchantId, venueId);

  if (draftVenue !== undefined) {
    reportInitialVenuesSetup(draftVenue.name);
  }

  return (
    <Root className={className}>
      <Wrapper>
        {draftVenueError ? (
          <APIErrorNotification error={draftVenueError} />
        ) : (
          draftVenue && (
            <>
              <Heading>{draftVenue.name}</Heading>
              <StyledNavigation />
              <Switch>
                <Route path={`${path}/general`}>
                  <DraftVenueEditorGeneral onSaveSuccess={() => history.push('./opening-hours')} />
                </Route>
                <Route path={`${path}/opening-hours`}>
                  <DraftVenueEditorOpeningHours onSaveSuccess={() => history.push('./confirm')} />
                </Route>
                <Route path={`${path}/confirm`}>
                  <DraftVenueEditorConfirm onSaveSuccess={onSaveSuccess} />
                </Route>
                <Route path={path}>
                  <Redirect to={`${url}/general`} />
                </Route>
              </Switch>
            </>
          )
        )}
      </Wrapper>
    </Root>
  );
};

export default DraftVenueEditor;
